import { Link } from 'react-router-dom';
import '../css/loader.css'

export function FooterMenu(props) {
    return <div id="contact" class="container-fluid bg-bluecode">
        {/* <h2 class="text-center text-small color-green">Autres liens</h2> */}
        <div class="row">
            <div class="col-sm-1" />
            <div class="col-sm-2 text-center">
                <img class="logoFooter" src={require("../img/Logo-white.png")} alt="" />
            </div>
            <div class="col-sm-6 slideanim text-center">
                <div class="row space-around">
                    <Link id='nav-acceuil' class='fotterTitleHover navSelected' to="/">Acceuil</Link>
                    <Link to="/quiSommeNous" className='fotterTitleHover'>Qui sommes-nous</Link>
                    <Link to="/nosSolutions" className='fotterTitleHover'>Nos Solutions</Link>
                </div>
                <div class="row space-around marginTop10">
                    <Link to="/carrieres" className='fotterTitleHover'>Carrières</Link>
                    <Link to="/contactezNous" className='fotterTitleHover'>Contactez-nous</Link>
                </div>
            </div>
            <div class="col-sm-3" />
        </div>
        <div className='greenSeperatorLinefull marginTop20'></div>
        <div class="col-sm-3" />
        <div class="col-sm-6 text-center marginTop20">
            <div class="row space-around">
                <text className='text-small color-white'>Adresse: Zgharta, Lebanon</text>
                <text className='text-small color-white'>|</text>
                <text className='text-small color-white'>Téléphone: +961 6 669 064</text>
                <text className='text-small color-white'>|</text>
                <a href='https://www.linkedin.com/company/pro-p-group/about/'><text className='text-small color-white'>LinkedIn: Pro-P Group</text></a>
            </div>
            <div class="col-sm-3" />
        </div>
    </div>
}

export function CompaniesItem(props) {
    return <div class="col-md-4 text-center">
        <div class="slide marginTop10 highlighted">
            <div class="testimonial-single-1">
                <div class="ts-person">
                    <div class="ts-img">
                        <img src="http://via.placeholder.com/80x80?text=Image" alt="" />
                    </div>
                    <h5>Vera Duncan</h5>
                    <span>PayPal Inc.</span>
                </div>
                <div class="ts-content">
                    <text class="text-12">This should be used to tell a story and let your users know about your product or service.</text>
                    <div class="rating">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export function AcceuilToggleItems(props) {
    return <a class="btn2" data-toggle="collapse" href={props.href} role="button" aria-expanded="false" aria-controls={props.aria} onClick={props.toggleView}>
        <div class="slide">
            <div class="box-info box-info-1 alignCenter column-div" id={props.id}>
                <div class="box-icon icon"><img src={props.image} alt="" /></div>
                <div class="box-content textWidthMax">
                    <text class="color-blue text-12">{props.title}</text>
                </div>
            </div>
        </div>
    </a>
}

export function AcceuilToggleItemsActive(props) {
    return <a class="btn2" data-toggle="collapse" href={props.href} role="button" aria-expanded="false" aria-controls={props.aria} onClick={props.toggleView}>
        <div class="">
            <div class="box-info box-info-1 active active1 alignCenter column-div" id={props.id}>
                <div class="box-icon icon acceuil-animation"><img src={props.image} alt="" /></div>
                <div class="box-content textWidthMax">
                    <div class="color-blue acceuil-toggle-title">{props.title}</div>
                </div>
            </div>
        </div>
    </a>
}

export function Loader(){
    return <div class="lds-dual-ring"><div></div><div></div><div></div><div></div></div>
}